"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const Icons_1 = require("../Icons");
const react_1 = require("react");
const styles_1 = require("./styles");
const hooks_1 = require("../../hooks");
const Drawer = (0, react_1.forwardRef)((props, ref) => {
  const {
    anchor = 'right',
    headerPrimary,
    headerSecondary,
    children,
    stylesOverride,
    onCollapse,
    isOpen,
    width = '820px',
    id,
    dataAutomationDrawer = 'drawer',
    dataAutomationToggle = 'toggle'
  } = props;
  const [mainHeight, setMainHeight] = (0, react_1.useState)(0);
  const isMounted = (0, hooks_1.useDelayedUnmount)(isOpen, 200);
  const headerRef = (0, react_1.useRef)(null);
  const onToggle = () => {
    onCollapse?.(false);
  };
  (0, react_1.useEffect)(() => {
    const handleResize = () => {
      if (headerRef.current && isMounted) {
        const parentEl = headerRef.current.parentElement;
        const parentHeight = parentEl?.offsetHeight || 0;
        const headerHeight = headerRef.current.offsetHeight;
        const newHeight = parentHeight - headerHeight;
        if (mainHeight !== newHeight) {
          setMainHeight(newHeight);
        }
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [headerRef, isMounted]);
  if (!isMounted) {
    return null;
  }
  return (0, jsx_runtime_1.jsx)(styles_1.Wrapper, {
    ref: ref,
    stylesOverride: stylesOverride,
    isOpen: isOpen,
    anchor: anchor,
    width: width,
    id: id,
    "data-automation": dataAutomationDrawer,
    children: (0, jsx_runtime_1.jsxs)(styles_1.Container, {
      children: [(0, jsx_runtime_1.jsx)(styles_1.CloseButton, {
        onClick: onToggle,
        "data-automation": dataAutomationToggle,
        children: (0, jsx_runtime_1.jsx)(Icons_1.CloseCircled, {})
      }), (0, jsx_runtime_1.jsx)(styles_1.ContainerHeader, {
        ref: headerRef,
        children: (headerPrimary || headerSecondary) && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
          children: [headerPrimary, headerSecondary, (0, jsx_runtime_1.jsx)(styles_1.Divider, {})]
        })
      }), children && (0, jsx_runtime_1.jsx)(styles_1.ContainerMain, {
        maxHeight: mainHeight,
        children: children
      })]
    })
  });
});
exports.default = Drawer;